"use strict";

angular.module('rmDashboard', []);

require('./controller');
require('./resources');
require('./directives');
require('./routes');
require('./services');

